const en = {
  showMore: 'Show more',
  showLess: 'Show less',
};

export default en;
